export const decodeHtml = html => {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
};

export const removeHtmlFromText = text => text.replace(/(<([^>]+)>)/gi, '');

export const truncateText = (text = '', limit = 80) => {
    if (text.length <= limit) {
        return text;
    }

    const trimmedAndSplit = text.slice(0, limit).split(' ');
    trimmedAndSplit.pop();
    return trimmedAndSplit.join(' ') + (text.length > limit ? '…' : '');
};
